import { render, staticRenderFns } from "./tree-context-menu.vue?vue&type=template&id=463e0885&"
import script from "./tree-context-menu.vue?vue&type=script&lang=js&"
export * from "./tree-context-menu.vue?vue&type=script&lang=js&"
import style0 from "./tree-context-menu.vue?vue&type=style&index=0&id=463e0885&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports